import { ClienteD3Response, ToggleD3Payload } from '../../types/cliente-d3';
import { api } from './base-api';

export const clienteD3Api = {
  async toggle(clienteId: string, payload: ToggleD3Payload): Promise<ClienteD3Response> {
    const { data } = await api.patch<ClienteD3Response>(
      `/admin/clientes/${clienteId}/d3`,
      payload,
    );
    return data;
  },
};
